import React from 'react'

export default function Marker({color = 'EEEAD9'}) {
    return (
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.859 3.4961C11.3277 3.76257 11.3277 4.43806 10.859 4.70453L6.26016 7.31913C6.04718 7.44022 5.78618 7.44023 5.57318 7.31917L0.973237 4.70457C0.504455 4.43811 0.504456 3.76251 0.973237 3.49606L5.57319 0.881461C5.78618 0.760396 6.04718 0.760409 6.26016 0.881496L10.859 3.4961Z" fill={`#${color}`}/>
        </svg>
    )
}
